/*
 * @Description: 注册指令
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-03 09:41:19
 */
import { MessageBox } from 'element-ui';
import { VTooltip } from 'v-tooltip';

function imgListener(ev) {
  MessageBox.alert(
    `<p style="max-height:600px;overflow-y:auto"><img style="width: auto;margin: 0 auto;margin-top:10px;display: block;" src=${ev.getAttribute(
      'src'
    )} /></p>`,
    ' ',
    {
      dangerouslyUseHTMLString: true,
      closeOnPressEscape: true,
      confirmButtonText: '关 闭',
      showConfirmButton: false,
      closeOnClickModal: true,
      showClose: true
    }
  ).catch(e => {
    console.error(e);
  });
}
// function fapiaoPic(ev) {
//   MessageBox.alert(
//     `<img style="width: auto;max-height:1030px;margin-top:10px;" src=${ev.target.src} />`,
//     ' ',
//     {
//       dangerouslyUseHTMLString: true,
//       closeOnPressEscape: true,
//       confirmButtonText: '关 闭',
//       showConfirmButton: false,
//       closeOnClickModal: true,
//       showClose: true
//     }
//   ).catch(e => {});
// }
// 图片弹窗展示
export const amplifyImg = {
  bind(el, binding) {
    if (binding.value) {
      el.addEventListener('click', imgListener.bind(this, el, binding), false);
    }
  },
  unbind(el, binding) {
    if (binding.value) {
      el.removeEventListener(
        'click',
        imgListener.bind(this, el, binding),
        false
      );
    }
  }
};

export const hovertip = VTooltip;
